import React from 'react';

interface Props {
  id: string;
}

export const CustomerMap = ({ id, }:Props) => {
  return (
    <div>
      mapa { id }
    </div>
  );
};
